// proceduralLibrary/presets/PresetPanel.jsx
//
// Preset image wallpapers (WP-IMG). A grid of 24 AI-generated presets shown as
// 240px THUMBNAILS (lazy-loaded); selecting one applies the full-resolution webp
// as the wallpaper image via the existing image path (onSelect -> currentBg 2).

import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { PRESETS } from "./manifest";

const PresetPanel = ({ onSelect }) => (
  <Box sx={{ p: 1 }}>
    <Typography
      sx={{ fontWeight: "bold", fontSize: "14px", pl: 1, mb: 1, fontFamily: "DM Sans" }}
    >
      Preset wallpapers
    </Typography>
    <Grid container spacing={1}>
      {PRESETS.map((p) => (
        <Grid item key={p.id}>
          <Box
            role="button"
            tabIndex={0}
            aria-label={p.label}
            title={p.label}
            onClick={() => onSelect && onSelect(p.full)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onSelect && onSelect(p.full);
              }
            }}
            sx={{
              width: 72,
              height: 48,
              borderRadius: "8px",
              overflow: "hidden",
              cursor: "pointer",
              border: "1px solid #e1e4e8",
              "&:hover": { borderColor: "#C9A8FF" },
              "&:focus-visible": { outline: "none", boxShadow: "0 0 0 2px #C283DA" },
            }}
          >
            <img
              src={p.thumb}
              alt={`${p.label} wallpaper`}
              loading="lazy"
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default PresetPanel;
